import { useErrorNotification } from '@/hooks/use-error-notification';
import { normalizeApiError } from '@/utils/error-utils';
import { useCallback } from 'react';

// Shows the standard error toast when a price edit is aborted because the row is missing
// currency decimals (see MissingCurrencyDecimalsError in table-helpers).
export const useMissingDecimalsNotification = () => {
  const showErrorNotification = useErrorNotification();

  return useCallback(
    (error: Error) =>
      showErrorNotification(normalizeApiError(error), 'update prices'),
    [showErrorNotification],
  );
};
